//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

/**
 * The main scrolling element on our webapp.
 * We scroll this instead of <body>.
 */
export const MAIN_SCROLL_TARGET_SELECTOR = 'cu-page-frame-scroll-wrap';

/**
 * An all-encompassing selector for our top nav elements.
 */
export const PAGE_HEADER_SELECTOR = '#sticky-header';
